// 1920 기준 디자인을 지금 창 폭으로 옮길 때 쓰는 배율.
//
// 글자에는 쓰지 않는다. 글자는 원본 px 그대로 두고 제목만 clamp 로 상한을 건다 —
// 그게 "모니터마다 글자 크기가 달라진다"를 없앤 방법이다.
//
// 이 배율은 두 군데에 쓴다.
//   1) 그림 층 — 핸드폰 목업 · 썸네일 모자이크 · 카드 줄 · 카드 휠처럼
//      1920 좌표에 묶여 있어 옮길 수 없는 덩어리를 통째로 줄일 때.
//   2) 세로 리듬 — 섹션 안팎의 여백. 여백까지 원본 px 로 고정했더니
//      1920 용으로 그린 넉넉한 간격이 1440 화면을 절반씩 비웠다.
//      글자는 고정이고 여백만 줄어들어야 원본 비율이 된다.
//
// 상한은 1 이다. 1920 을 넘는 화면에서는 더 키우지 않는다 —
// 그래야 1920 · 2560 · 3840 이 완전히 같게 보인다.
import { onBeforeUnmount, onMounted, ref } from 'vue'

export const DESIGN_WIDTH = 1920

/**
 * @param {import('vue').Ref<HTMLElement|null>} target  폭을 잴 요소(보통 섹션 뿌리)
 * @returns {{ scale: import('vue').Ref<number>, measure: () => void }}
 */
export function useDesignScale(target) {
  const scale = ref(1)
  let observer = null

  const measure = () => {
    const width = target.value?.clientWidth
    if (!width) return
    scale.value = Math.min(1, width / DESIGN_WIDTH)
  }

  // ResizeObserver 와 window.resize 를 같이 듣는다.
  // 요소 폭이 안 바뀌는데 창만 바뀌는 경우(세로만 줄이기, 탭이 가려져 있다가 돌아오기)가 있고,
  // 그때 ResizeObserver 는 울리지 않는다.
  onMounted(() => {
    measure()
    observer = new ResizeObserver(measure)
    if (target.value) observer.observe(target.value)
    window.addEventListener('resize', measure)
  })

  onBeforeUnmount(() => {
    observer?.disconnect()
    observer = null
    window.removeEventListener('resize', measure)
  })

  return { scale, measure }
}
